<template>
  <div class="page" id="page-cs">

    <div class="section-header">
      <div class="container">
        <h1>공지사항</h1>
      </div>
    </div>

    <div class="section-body" id="notice">
      <div class="container">
        <div class="section-search">
          <input class="searchBox" v-on:keyup.enter="search" v-model="searchText" />
          <img class="searchButton" :src="'../static/search.png'" @click="search">
        </div>
        <div class="section-list">


          <element-board>
            <element-board-item :key="index" v-for="(items, index) in data" @clickLazy="updateClicks(items)" @click="openItem === index ? openItem = -1 : openItem = index" :on="openItem == index">
              {{ items.post_subject }}
              <span>
                {{ "날짜 " }} {{ moment(items.createdAt).format('YYYY. MM. DD') }}
                &nbsp&nbsp
                {{ "조회수 " + items.post_view_count }}
              </span>
              <img :src="openItem == index ? '../static/expand_less_primary.png' : '../static/expand_more.png'" />

              <div class="item-description" v-if="openItem == index && items.post_content">
                {{ items.post_content }}
              </div>
            </element-board-item>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              size="sm"
               @input =" updatePage(currentPage); "
              align="center">
            </b-pagination>
          </element-board>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import moment from 'moment';
export default {
  data(){
    return {
      perPage: 10,
      rows: 10,
      currentPage: 1,
      moment: moment,

      searchText: '',
      openItem: -1,
      data: [
        { "id": "1", "title": "자동차보험 문의",  "description": "testtesttest", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "2", "title": "문의", "description": "testtestttesttesttestt", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "3", "title": "사고 관련 상담 희망합니다.", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "4", "title": "보험료계산 문의", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "5", "title": "자동차보험 문의", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "6", "title": "상담 변경 부탁드립니다.", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "7", "title": "운전자보험 문의", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "8", "title": "유병자보험", "description": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "9", "title": "실비보험 문의", "description": "실비보험을 오래전에 들은 거라 질병 통원비가 10만원 한도 내에서만 나오는거라 많이 약해 보강 좀 하려고 합니다. 제 담당자께서 정태현 설계사님이신데 전화 좀 부탁드릴께요.", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "10", "title": "회원탈퇴 요청", "description": "", "createAt": "2019-04-09", "clicks": "13" },
      ]
    }
  },
  created() {
    this.updatePage(1);
  },
  methods: {
      clickTab(tab){
        this.introductionTab = tab;

        this.updatePage(1);
      },
      updateClicks(item){
        this.$store.dispatch( "post/updateClicks", { _id: item._id} ).then(res => {
          this.updatePage(this.currentPage);
        })
      },
      search(evt){
        this.updatePage(1);
      },
      updatePage(page){
        this.$data.currentPage = page;
        this.$trackingService('init', '001-004-761');
        this.$trackingService('track', 'Search');

        this.$store.dispatch( "post/getItems", { page: this.currentPage, size: 10, post_type: "notice", search_text: this.searchText } ).then( res => {
          this.data = res.data.data.items;          
        });
      }
  }
}
</script>
